export enum NetworksType {
  TRX_USDT_S2UZ = 'TRX_USDT_S2UZ',
  USDT_BSC = 'USDT_BSC',
  USDT_ERC20 = 'USDT_ERC20',
}
